import(/* webpackMode: "eager" */ "/app/src/app/mobileApp/layout.js");
